import React from "react";

function RadialSeparators({ percent }) {
  return (
    <div
      className="radical-separator"
      style={{
        transform: `rotate(${percent / 100}turn)`,
      }}
    >
      <div className={"child"} />
    </div>
  );
}

export default RadialSeparators;
